<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M10.0002 12.6705L7.72745 10.3584L6.81836 11.1908L10.0002 14.4278L15.7274 8.60117L14.8184 7.7688L10.0002 12.6705Z"
    fill="#748097"
  />
  <path
    d="M11.2727 26.1733C12.8181 26.1733 14 24.971 14 23.4912H8.54541C8.54541 24.971 9.72723 26.1733 11.2727 26.1733Z"
    fill="#748097"
  />
  <path
    d="M11.4545 18.6821C15.2703 18.6821 18.3636 15.5351 18.3636 11.6532C18.3636 7.77121 15.2703 4.62427 11.4545 4.62427C7.63872
    4.62427 4.54541 7.77121 4.54541 11.6532C4.54541 15.5351 7.63872 18.6821 11.4545 18.6821Z"
    fill="#748097"
  />
  <path
    d="M24.0909 16.2773C19.909 16.2773 16.5454 19.6993 16.5454 23.9536C16.5454 28.208 19.909 31.6299 24.0909 31.6299C28.2727
    31.6299 31.6363 28.208 31.6363 23.9536C31.6363 19.6993 28.2727 16.2773 24.0909 16.2773ZM22.6363 27.7456L18.909 23.9536L20
    22.8438L22.7272 25.6184L28.4545 19.7918L29.5454 20.9016L22.6363 27.7456Z"
    fill="#009DD6"
  />
  <path
    d="M19.4547 15.1675V11.5606C19.4547 7.49122 17.182 4.06925 13.2729 3.1444V2.21954C13.3638 1.2022 12.3638 0.277344 11.2729
    0.277344C10.182 0.277344 9.27286 1.2022 9.27286 2.31203V3.23688C5.27286 4.06925 3.09104 7.49122 3.09104 11.5606V18.2195L0.36377 20.9016V22.1964H14.8183C15.182 19.2369 16.9092 16.6473 19.4547 15.1675ZM4.90922 11.1906C4.90922 7.5837 7.72741 4.71665 11.2729 4.71665C14.8183 4.71665 17.6365 7.5837 17.6365 11.1906C17.6365 14.7976 14.8183 17.6646 11.2729 17.6646C7.72741 17.6646 4.90922 14.7976 4.90922 11.1906Z"
    fill="#748097"
  />
</svg>
